import type { FC, ReactNode } from "react";

import { cn } from "@/lib/utils";

type Props = {
  title: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  /** Remove the body padding (for lists / tables). */
  flush?: boolean;
  /** Drop the outer border (when embedding inside another card or a hairline grid). */
  embedded?: boolean;
};

/**
 * An elevated card with a title row, used by the overview and record
 * sections.
 */
export const SectionCard: FC<Props> = ({
  title,
  action,
  children,
  className,
  flush = false,
  embedded = false
}) => (
  <div
    data-slot="section-card"
    data-embedded={embedded || undefined}
    className={cn(
      "flex w-full min-w-0 flex-col overflow-hidden bg-elevated text-fg",
      !embedded && "rounded-lg ring-1 ring-line-2",
      className
    )}
  >
    <header className="flex h-10 shrink-0 items-center justify-between gap-2 border-b border-line-1 px-4">
      <span className="truncate text-base font-medium text-fg">{title}</span>
      {action ? (
        <div className="flex shrink-0 items-center gap-1">{action}</div>
      ) : null}
    </header>
    <div className={cn("flex min-w-0 flex-col", !flush && "p-4")}>
      {children}
    </div>
  </div>
);
